function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Container } from "../../Container/Container/Container";
import styles from "./IconCardSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconCard = function IconCard(_ref) {
  var image = _ref.image,
    headline = _ref.headline,
    description = _ref.description;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.card,
    children: [image && /*#__PURE__*/_jsx(Image, _objectSpread({}, image)), /*#__PURE__*/_jsx(HeadingText, {
      className: styles.cardHeadline,
      align: "left",
      typog: "subhead3",
      children: headline
    }), /*#__PURE__*/_jsx(Text, {
      richText: true,
      align: "left",
      typog: "bodycopy",
      children: description
    })]
  });
};
export var IconCardSlice = function IconCardSlice(_ref2) {
  var headline = _ref2.headline,
    cards = _ref2.cards;
  return /*#__PURE__*/_jsxs(Container, {
    children: [headline && /*#__PURE__*/_jsx(HeadingText, {
      className: styles.headline,
      align: headline.align,
      ariaLevel: headline.ariaLevel,
      typog: headline.typog || 'headline4',
      children: headline.text
    }), /*#__PURE__*/_jsx("div", {
      className: styles.cards,
      children: cards === null || cards === void 0 ? void 0 : cards.map(function (card, index) {
        return /*#__PURE__*/_jsx(IconCard, _objectSpread({}, card), "icon-card-".concat(index));
      })
    })]
  });
};